var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUUsersAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 12,
    fill: "#FFF8CD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_458_978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 17C19.3261 17 20.5979 17.5268 21.5355 18.4645C22.4732 19.4021 23 20.6739 23 22V28H13V22C13 20.6739 13.5268 19.4021 14.4645 18.4645C15.4021 17.5268 16.6739 17 18 17ZM11.288 20.006C11.1289 20.5428 11.0348 21.0968 11.008 21.656L11 22V28H8V23.5C7.9998 22.6376 8.31803 21.8054 8.89363 21.1632C9.46924 20.521 10.2617 20.1139 11.119 20.02L11.289 20.006H11.288ZM24.712 20.006C25.6019 20.0602 26.4376 20.452 27.0486 21.1012C27.6596 21.7505 27.9999 22.6084 28 23.5V28H25V22C25 21.307 24.9 20.638 24.712 20.006ZM11.5 14C12.163 14 12.7989 14.2634 13.2678 14.7322C13.7366 15.2011 14 15.837 14 16.5C14 17.163 13.7366 17.7989 13.2678 18.2678C12.7989 18.7366 12.163 19 11.5 19C10.837 19 10.2011 18.7366 9.73223 18.2678C9.26339 17.7989 9 17.163 9 16.5C9 15.837 9.26339 15.2011 9.73223 14.7322C10.2011 14.2634 10.837 14 11.5 14ZM24.5 14C25.163 14 25.7989 14.2634 26.2678 14.7322C26.7366 15.2011 27 15.837 27 16.5C27 17.163 26.7366 17.7989 26.2678 18.2678C25.7989 18.7366 25.163 19 24.5 19C23.837 19 23.2011 18.7366 22.7322 18.2678C22.2634 17.7989 22 17.163 22 16.5C22 15.837 22.2634 15.2011 22.7322 14.7322C23.2011 14.2634 23.837 14 24.5 14ZM18 8C19.0609 8 20.0783 8.42143 20.8284 9.17157C21.5786 9.92172 22 10.9391 22 12C22 13.0609 21.5786 14.0783 20.8284 14.8284C20.0783 15.5786 19.0609 16 18 16C16.9391 16 15.9217 15.5786 15.1716 14.8284C14.4214 14.0783 14 13.0609 14 12C14 10.9391 14.4214 9.92172 15.1716 9.17157C15.9217 8.42143 16.9391 8 18 8Z",
    fill: "url(#paint0_linear_458_978)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_978",
    x1: 28,
    y1: 18.0935,
    x2: 8.00453,
    y2: 18.3943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2800D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_458_978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUUsersAlt);
export default __webpack_public_path__ + "static/media/u_users-alt.c53db7b8a7f8ac1f79d8758ac7292568.svg";
export { ForwardRef as ReactComponent };